import type {IBlog} from "../store/blog/Helper";
import type {IWish} from "../store/wish/Helper";
import {RoutePaths} from "./constants";

export const getWishRouteIdentifier = (wish: Pick<IWish, "id" | "slug">) => wish.slug || wish.id;

export const doesWishMatchRouteIdentifier = (
    wish: Pick<IWish, "id" | "slug">,
    routeIdentifier?: string
) => (
    Boolean(routeIdentifier) &&
    (wish.id === routeIdentifier || Boolean(wish.slug && wish.slug === routeIdentifier))
);

export const getWishDetailsPath = (wish: Pick<IWish, "id" | "slug">) => (
    `${RoutePaths.WISHES}/${getWishRouteIdentifier(wish)}`
);

export const getWishWinnerPath = (wish: Pick<IWish, "id" | "slug">) => (
    `${getWishDetailsPath(wish)}/winner`
);

export const getWishPreferredUrl = (wish: Pick<IWish, "id" | "slug">) => (
    `https://genie.mk${getWishDetailsPath(wish)}`
);

export const getBlogRouteIdentifier = (blog: Pick<IBlog, "id" | "slug">) => blog.slug || blog.id;

export const getBlogDetailsPath = (blog: Pick<IBlog, "id" | "slug">) => (
    `${RoutePaths.BLOGS}/${getBlogRouteIdentifier(blog)}`
);

export const getBlogPreferredUrl = (blog: Pick<IBlog, "id" | "slug">) => (
    `https://genie.mk${getBlogDetailsPath(blog)}`
);
